<script>

import Service from '../../services/material-balance'
import Toolbar from 'primevue/toolbar';
import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';

//import MaterialBalanceService from '../../services/material-balance';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue';
import GenericCustomMultiSelect from '../../components/generic/GenericCustomMultiSelect.vue';

export default {
    setup: () => ({ v$: useVuelidate() }),
    props: [],
    components: { Toolbar, ResponsiveButton, GenericDataTable, GenericCustomMasterDataAutocompleteV2, GenericCustomMultiSelect },
    data() {
        return {
            filters: {
                stockDate: Utils.setDay(new Date(), 1),
            },
            submitted: false,
            copyFromSubmitted: false,
            addProductStockDialogVisible: false,
            addProductStockItem: {},
            addProductStockSubmitted: false,
            copyFromDialogVisible: false,
            importFromDialogVisible: false,
            importFromData: {},
            importFromSubmitted: false,
            copyFromStock: {},
            tabs: [],
            activeTab: 0,
            configuration: {},
            exportStockSubmitted: false,
            exportStockDialogVisible: false,
            exportStockData: {},
        }
    },
    created() {
        this.configuration = config.getConfiguration('ProductStock');
    },
    validations() {
        return {
            filters: {
                stockDate: { required },
            },
            addProductStockItem: {
                balanceSheetDate: { required },
                idRegistryPlant: (data) => data.idRegistryPlant || data.idRegistryCompany,
                idRegistryProduct: { required },
                quantity: { required },
                idRegistryCompany: (data) => data.idRegistryPlant || data.idRegistryCompany,
                idRegistryOriginStorage: { required },
            },
            copyFromStock: {
                dateTo: { required },
                dateFrom: { required },
            },
            exportStockData: {
                balanceSheetDate: {required},
                idRegistryPlant: {},
            },
            importFromData: {
                stockDate: {required},
                origins: {required}
            }
        }
    },
    mounted() {
        this.$store.dispatch('security/setNavbarTitle', 'productStock.page_title');
        this.loadProducts(true);
    },
    watch: {
        tabs(newValue) {
            setTimeout(() => 
            newValue.forEach((element, index) => {
                let filtersGrid = [];

                if (element.idRegistryCompany){
                    filtersGrid.push({
                        operator: 'eq',
                        value: element.idRegistryCompany,
                        property: 'IdRegistryCompany',
                    });
                } else if(element.idRegistryPlant){
                    filtersGrid.push({
                        operator: 'eq',
                        value: element.idRegistryPlant,
                        property: 'IdRegistryPlant',
                    });
                }

                filtersGrid.push({
                    operator: 'eq',
                    value: Utils.formatDateForAPI(this.filters.stockDate),
                    property: 'BalanceSheetDate',
                });

                this.$refs.productStockGrid[index].setGlobalFilters(filtersGrid);
                this.$refs.productStockGrid[index].filterFromView(filtersGrid, false);
            }), 300)
        },
        exportStockDialogVisible(newValue){
            if(!newValue){
                this.exportStockData = {};
                this.exportStockSubmitted = false;
            }
        },
        addProductStockDialogVisible(newValue){
            if(!newValue){
                this.addProductStockItem = {};
                this.addProductStockSubmitted = false;
            }
        },
        importFromDialogVisible(newValue){
            if(!newValue){
                this.importFromData = {};
                this.importFromSubmitted = false;
            }
        },
        copyFromDialogVisible(newValue){
            if(!newValue){
                this.copyFromStock = {};
                this.copyFromSubmitted = false;
            }
        },
    },
    computed: {
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
    },
    methods: {
        loadProducts(valid) {
            this.submitted = true;
            if (valid) {
                this.loadGrid();
            }
        },
        loadGrid() {
            let filters = [];

            filters.push({
                operator: '<=',
                value: Utils.formatDateForAPI(this.filters.stockDate),
                property: 'StartDate',
            });

            filters.push({
                operator: '>=',
                value: Utils.formatDateForAPI(this.filters.stockDate),
                property: 'ExpireDate',
            });

            let params = {
              filter: JSON.stringify(filters),
            }

            Service.getCompanySection(params, ({success, data}) => {
                if (success){
                    this.tabs = data.sort((a, b) => a.position - b.position);
                }
            })
        },
        onDialogEditSave(data) {
            this.$store.dispatch("generic/setLoading", true);
            Service.updateProductStock(data, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.loadGrid();
                    this.$refs.productStockGrid[this.activeTab].hideDialogEdit();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        addProductStockSave() {
            this.addProductStockSubmitted = true;
            if (!this.v$.addProductStockItem.$invalid) {
                this.addProductStockItem.balanceSheetDate = Utils.formatDateForAPI(Utils.setDay(this.addProductStockItem.balanceSheetDate, 1));
                this.$store.dispatch("generic/setLoading", true);
                Service.addProductStock(this.addProductStockItem, (response) => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.addProductStockSubmitted = false;
                    this.addProductStockDialogVisible = false;
                    this.addProductStockItem = {};
                    if (response.success) {
                        this.loadGrid();
                        this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                })
            }
        },
        copyFromSave(){
            this.copyFromSubmitted = true;
            if(!this.v$.copyFromStock.$invalid){
                Service.copyFromStockDate({dateFrom: this.copyFromStock.dateFrom, dateTo: this.copyFromStock.dateTo}, (response) => {
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        },
        importFromSubmit(){
            this.importFromSubmitted = true;
            if(!this.v$.importFromData.$invalid){
                if(this.importFromData.origins.some((item) => item === 'BMM')){
                    Service.importFromBMMProductStock({balanceSheetDate: Utils.formatDateForAPI(this.importFromData.stockDate)}, ({success, message}) => {
                        if(success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        }else{
                            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                }
                if(this.importFromData.origins.some((item) => item === 'IGCC')){
                    Service.importFromIgccProductStock({balanceSheetDate: Utils.formatDateForAPI(this.importFromData.stockDate)}, ({success, message}) => {
                        if(success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        }else{
                            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    })
                }
            }
        },
        exportStockExcel() {
            this.exportStockSubmitted = true;
            if(!this.v$.exportStockData.$invalid){

                const balanceSheetDate = Utils.formatDateForAPI(this.exportStockData.balanceSheetDate);
                
                let params = {
                    balanceSheetDate,
                    idRegistryPlant: this.exportStockData.idRegistryPlant,
                    idRegistryCompany: this.exportStockData.idRegistryCompany,
                };
                
                this.$store.dispatch("generic/setLoading", true);
                Service.exportMaterialBalanceLotManagementStock(params, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.exportStockDialogVisible = false;
                        this.exportStockSubmitted = false;
    
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                    
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', balanceSheetDate + '.xlsx');
                        document.body.appendChild(fileLink);
                    
                        fileLink.click();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        },
    },
}

</script>

<template>
    <main>
        <Dialog v-model:visible="addProductStockDialogVisible" :style="{ width: '50vw' }" :modal="true">
            <div class="grid">
                <template v-for="field in configuration.columns" :key="field.name">
                    <template v-if="!field.formHide">
                        <div class="col-12">
                            <label :for="field.name"
                                :class="{ 'p-error': v$.addProductStockItem?.[field.updateField ?? field.name]?.$invalid && addProductStockSubmitted }">{{ $t(field.label) }}</label>
                            <InputText v-if="field.type == 'string'" class="w-full" v-model="addProductStockItem[field.name]" />
                            <InputText class="w-full" type="number" v-if="field.type == 'number'"
                                v-model="addProductStockItem[field.name]" />
                            <InputNumber class="w-full" mode="decimal" :maxFractionDigits="field.digits"
                                v-if="field.type == 'decimal'" v-model="addProductStockItem[field.name]" />
                            <Calendar
                                v-if="field.type == 'date'" class="w-full"
                                placeholder="MM/AAAA"
                                view="month" dateFormat="mm/yy" :showTime="false" v-model="addProductStockItem[field.name]"
                                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                            <GenericCustomMasterDataAutocompleteV2 v-if="field.type == 'select'" :name="field.updateField"
                                v-model="addProductStockItem[field.updateField ?? field.name]" :api="field.selectApi"
                                :format="field.selectFormat" :defaultValue="field.defaultValue" :disableStore="true" />
                            <Textarea class="w-full" v-if="field.type == 'textarea'" v-model="addProductStockItem[field.name]" />
                            <div
                                v-if="(v$.addProductStockItem?.[field.updateField ?? field.name]?.$invalid && addProductStockSubmitted) || v$.addProductStockItem?.[field.updateField ?? field.name]?.$pending.$response">
                                <small class="p-error"
                                    v-for="error in v$.addProductStockItem?.[field.updateField ?? field.name]?.$silentErrors"
                                    :key="error.$validator">
                                    {{ error.$message }}
                                </small>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <template #footer>
                <Button :label="$t('btn.save')" icon="pi pi-save" @click="addProductStockSave" autofocus />
            </template>
        </Dialog>
        <Dialog v-model:visible="exportStockDialogVisible" :style="{ width: '250px' }" :modal="true">
            <div class="grid">
                <div class="col-12">
                    <label for="balanceSheetDate"
                        :class="{ 'p-error': v$.exportStockData.balanceSheetDate.$invalid && exportStockSubmitted }">{{ $t('productStock.balanceSheetDate') }}</label>
                    <Calendar class="w-full"
                        placeholder="MM/AAAA" view="month" dateFormat="mm/yy" :showTime="false" :showIcon="true"
                        v-model="exportStockData.balanceSheetDate" />
                    <div v-if="(v$.exportStockData.balanceSheetDate.$invalid && exportStockSubmitted) || v$.exportStockData.balanceSheetDate.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.exportStockData.balanceSheetDate.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
                <div class="col-12">
                    <label for="idRegistryPlant"
                        :class="{ 'p-error': v$.exportStockData.idRegistryPlant.$invalid && exportStockSubmitted }">{{ $t('registryPlant.fk') }}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        v-model="exportStockData.idRegistryPlant" api="masterdata/registry-plant-combo" />
                    <div v-if="(v$.exportStockData.idRegistryPlant.$invalid && exportStockSubmitted) || v$.exportStockData.idRegistryPlant.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.exportStockData.idRegistryPlant.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('btn.export')" icon="pi pi-file" @click="exportStockExcel" autofocus />
            </template>
        </Dialog>
        <Dialog v-model:visible="copyFromDialogVisible" :style="{ width: '250px' }" :modal="true">
            <div class="grid">
                <div class="col-12">
                    <label for="dateFrom" :class="{ 'p-error': v$.copyFromStock.dateFrom.$invalid && copyFromSubmitted }">{{$t('productStock.copyFromDate')}}</label>
                    <Calendar
                        class="p-inputtext-sm w-full"
                        placeholder="__/____"
                        v-model="copyFromStock.dateFrom"
                        view="month" dateFormat="mm/yy" :showTime="false"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                    <div v-if="(v$.copyFromStock.dateFrom.$invalid && copyFromSubmitted) || v$.copyFromStock.dateFrom.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.copyFromStock.dateFrom.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
                <div class="col-12">
                    <label for="dateTo" :class="{ 'p-error': v$.copyFromStock.dateTo.$invalid && copyFromSubmitted }">{{$t('productStock.stockDate')}}</label>
                    <Calendar
                        class="p-inputtext-sm w-full"
                        placeholder="__/____"
                        v-model="copyFromStock.dateTo"
                        view="month" dateFormat="mm/yy" :showTime="false"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                    <div v-if="(v$.copyFromStock.dateTo.$invalid && copyFromSubmitted) || v$.copyFromStock.dateTo.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.copyFromStock.dateTo.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('productStock.btn.copyFrom')" icon="pi pi-plus" @click="copyFromSave" autofocus />
            </template>
        </Dialog>
        <Dialog v-model:visible="importFromDialogVisible" :style="{ width: '40vw' }" :modal="true">
            <div class="grid">
                <div class="col-12">
                    <label for="stockDate" :class="{ 'p-error': v$.importFromData.stockDate.$invalid && importFromSubmitted }">{{$t('productStock.stockDate')}}</label>
                    <Calendar
                        class="p-inputtext-sm w-full"
                        placeholder="__/____"
                        v-model="importFromData.stockDate"
                        view="month" dateFormat="mm/yy" :showTime="false"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                    <div v-if="(v$.importFromData.stockDate.$invalid && importFromSubmitted) || v$.importFromData.stockDate.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.importFromData.stockDate.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
                <div class="col-12">
                    <label for="origin"
                        :class="{ 'p-error': v$.importFromData.origins.$invalid && importFromSubmitted }">{{ $t('productStock.origins') }}</label>
                    <GenericCustomMultiSelect
                        v-model="importFromData.origins" 
                        :format="{label: 'label', value: 'value'}"
                        :options="[{label: 'BMM', value:'BMM'},{label: 'STOCCHINO IGCC', value:'IGCC'}]"
                        class="p-inputtext-sm w-full" />
                    <div v-if="(v$.importFromData.origins.$invalid && importFromSubmitted) || v$.importFromData.origins.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.importFromData.origins.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('btn.import')" icon="pi pi-plus" @click="importFromSubmit" autofocus />
            </template>
        </Dialog>
        <Toolbar>
            <template #start>
                <div class="formgrid grid">
                    <div class="col-12 lg:col-4 field">
                        <label :class="{ 'p-error': v$.filters.stockDate.$invalid && submitted }">{{ $t('productStock.stockDate') }}</label>
                        <Calendar
                            :class="{ 'p-invalid': v$.filters.stockDate.$invalid && submitted, 'p-inputtext-sm w-full': true }"
                            placeholder="MM/AAAA"
                            view="month" dateFormat="mm/yy" :showTime="false" v-model="filters.stockDate"
                            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                        <div v-if="(v$.filters.stockDate.$invalid && submitted) || v$.filters.stockDate.$pending.$response">
                            <small class="p-error" v-for="error in v$.filters.stockDate.$silentErrors"
                                :key="error.$validator">
                                {{ error.$message }}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-8 my-4">
                        <ResponsiveButton :label="$t('btn.refresh')"
                            icon="pi pi-sync" class="p-button-sm m-1" @click="loadProducts(!v$.filters.$invalid)" />
                        <ResponsiveButton :label="$t('btn.export')" :disabled="!uiPermissions('producstStockExportButton').isEnabled" @click="exportStockDialogVisible = true" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('btn.add')" :disabled="!uiPermissions('productStockAddButton').isEnabled"
                            @click="addProductStockDialogVisible = true" icon="pi pi-plus"
                            class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('productStock.btn.importFrom')"
                            :disabled="!uiPermissions('productStockImportFromButton').isEnabled" @click="importFromDialogVisible = true"
                            icon="pi pi-download" class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('productStock.btn.copyFrom')"
                            :disabled="!uiPermissions('productStockCopyFromButton').isEnabled" @click="copyFromDialogVisible = true"
                            icon="pi pi-clone" class="p-button-sm p-button-outlined m-1" />
                    </div>
                </div>
            </template>
        </Toolbar>
        <div class="col-12">
            <TabView v-model:activeIndex="activeTab">
                <TabPanel v-for="tab in tabs" :header="tab.description" :key="tab.description" >
                    <GenericDataTable :configuration="configuration" :category="'material-balance'" :name="'product-stock'"
                        ref="productStockGrid" :onDialogEditSave="onDialogEditSave" />
                </TabPanel>
            </TabView>
        </div>
    </main>
</template>